<script lang="ts" setup>
import { getImageUrl } from "@/shared/getImageUrl";
import { mdiArrowRightThin } from "@mdi/js";
import { isVlaams } from "@/utils/isVlaams";
</script>

<template>
  <v-container class="my-16" style="max-width: 80rem">
    <v-row align="center" justify="center">
      <v-col cols="12" md="7">
        <h2 class="pb-4">Over het programma</h2>

        <template v-if="isVlaams()">
          <p class="pb-4">
            Taalblobs is een adaptief oefenprogramma voor de Nederlandse
            spelling. In het programma zijn woorden opgenomen die overeenkomen
            met de leerstof van alle leerjaren van de lagere school.
          </p>
          <p class="pb-4">
            Het programma is in basis volledig adaptief en het kan daardoor heel
            gemakkelijk worden gebruikt in de klas als aanvulling op de
            reguliere lesmethode. Daarnaast is het zeer eenvoudig om
            maatwerkprogramma's samen te stellen voor onderwijsspecialisten
            (Logopedisten). Ook is Taalblobs geschikt voor thuisgebruik
            (aanschaf door ouders)
          </p>
        </template>
        <template v-else>
          <p class="pb-4">
            Taalblobs is een adaptief oefenprogramma voor de Nederlandse
            spelling. In het programma zijn woorden opgenomen die overeenkomen
            met de leerstof van begin groep 3 tot eind groep 8 van het
            basisonderwijs.
          </p>
          <p class="pb-4">
            Het programma is in basis volledig adaptief en het kan daardoor heel
            gemakkelijk worden gebruikt in de klas als aanvulling op de
            reguliere lesmethode. Taalblobs is daarnaast ook uitstekend geschikt
            voor thuisgebruik (aanschaf door ouders) en voor
            onderwijsspecialisten die een maatwerk programma willen samenstellen
            (Remedial Teachers).
          </p>
        </template>

        <v-btn :to="{ name: 'school-rt-thuis' }" color="primary">
          lees verder
          <v-icon class="ml-3">{{ mdiArrowRightThin }}</v-icon>
        </v-btn>
      </v-col>
      <v-col align="center" cols="12" md="5">
        <v-img
          :src="getImageUrl('/assets/website/diana.jpg')"
          transition="slide-y-reverse-transition"
          max-width="280"
          alt=""
        />
      </v-col>
    </v-row>
  </v-container>
</template>
